import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'src/classnames';
import { makeStyles } from 'src/makeStyles';
import { Trans } from 'src/i18n';
import NextLink from 'components/NextLink';
import { selectIsLoggedInState } from 'store/selectors';
import { TP, ARTIST_TYPE_ID } from 'constants/consts';
import route from 'constants/routes';

const useStyles = makeStyles()({
  root: {
    display: 'none',
    fontSize: 14,
  },
});

const ArtistCreateAccountLink = ({ spacing, align }) => {
  const { classes } = useStyles();
  const isLoggedIn = useSelector(selectIsLoggedInState());

  if (isLoggedIn) return null;

  return (
    <div className={cn(classes.root, 'vwo-artist-create-account')} style={{ margin: spacing, textAlign: align }}>
      <Trans
        ns="NS_APP_GLOBALS"
        i18nKey={`${TP}.ARTIST_CREATE_ACCOUNT_LINK`}
        components={{
          a: <NextLink href={`${route.REGISTER}?as=${ARTIST_TYPE_ID}&ref=create-artist`} />,
        }}
      />
    </div>
  );
};

export default ArtistCreateAccountLink;
